// extracted by mini-css-extract-plugin
module.exports = {"highlights":"Highlights_highlights__adj8k","title":"Highlights_title__3MrH_","wrapper":"Highlights_wrapper__31zp9"};